import {
  OverflowTooltip,
  Table,
  useNotificationContext,
} from "@4uhub/lib4uhub";
import { GridColDef, GridRowParams } from "@mui/x-data-grid";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { listGeneration } from "./list-generation.mock";
import { IListsGeneration } from "./models";
import PlaylistAddCheckIcon from "@mui/icons-material/PlaylistAddCheck";

const translationPath = "page.4uDlist.listGeneration.";

const ListGenerationPage = () => {
  const navigate = useNavigate();

  const { t } = useTranslation();

  const { setMessage } = useNotificationContext();

  const columns: GridColDef<IListsGeneration>[] = [
    {
      field: "name",
      headerName: t(translationPath + "name") || "Name",
    },
    {
      field: "generationRule",
      headerName: t(translationPath + "generation_rule") || "Generation Rule",
      renderCell: (params) => {
        if (!params.value) return "-";
        return (
          <OverflowTooltip
            text={params.value.name}
            tooltip={params.value.name}
            textTransform="none"
            variant="body2"
          />
        );
      },
    },
  ];

  const handleAdd = () => {
    navigate("new");
  };

  const handleRowClick = (params: GridRowParams<IListsGeneration>) => {
    navigate(`${params.id.toString()}/edit`);
  };

  return (
    <Table<IListsGeneration>
      showDefaultMacroFilters={false}
      rows={listGeneration}
      columns={columns}
      title={t(translationPath + "lists_generation")}
      searchInput
      onAdd={handleAdd}
      onRowClick={handleRowClick}
      rowActions={[
        {
          action: () => {
            setMessage({
              message: t(translationPath + "generated_successfully"),
              type: "success",
            });
          },
          icon: <PlaylistAddCheckIcon />,
          text: t(translationPath + "generate_list"),
        },
      ]}
      searchInputPlaceHolder={t(translationPath + "search")}
      addButtonLabel={
        t(translationPath + "add_list_generation") || "Add Generate List"
      }
      confirmOptions={{
        title: t(translationPath + "confirm.title"),
        description: t(translationPath + "confirm.description"),
        confirmationButtonProps: {
          variant: "contained",
        },
      }}
    />
  );
};

export default ListGenerationPage;
